$ = require 'jquery'
Auth = require 'db/auth'
BoardsSidebarBoardsButtonsView = require './boards-sidebar-boards-buttons-view'
BoardsSidebarAllBoardsView = require './boards-sidebar-all-boards-view'
BoardsSidebarFilteredBoardsView = require './boards-sidebar-filtered-boards-view'
BoardsSidebarSearchingButtonsView = require './boards-sidebar-searching-buttons-view'
Controller = require 'controller'
Hearsay = require 'hearsay'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
ModelLoader = require 'db/model-loader'
Monitor = require 'lib/monitor'
Payloads = require 'network/payloads'
PopOver = require 'views/lib/pop-over'
SidebarState = require 'view-models/sidebar-state'
UserInput = require 'views/internal/user-input'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
f = require 'effing'
template = require 'views/templates/boards_sidebar'
l = require 'lib/localize'

module.exports = class BoardsSidebarView extends View
  UNREAD_POLL_RATE_ACTIVE: Util.getMs(minutes: 5)
  UNREAD_POLL_RATE_IDLE: Util.getMs(minutes: 60)
  className: -> "boards-drawer"

  initialize: ->
    @searchText = @slot('')
    @isSearching = @searchText.map(f.compose(f.not, _.isEmpty)).distinct()

    Object.defineProperty(@, '$searchInput', get: -> @$('.js-search-boards'))

    @listenTo SidebarState, 'change:showBoardsListSidebar', ->
      @renderSidebarState()
      @ensureUnreadData()
      if SidebarState.getShowSidebar() || SidebarState.getPinSidebar()
        # a defer?! the "b" shortcut focuses the input (all good), but
        # the keyup event inserts a "b" in the field and starts filtering
        # (not good). just give it a second.
        # (the defer is not necessary if sidebar was brought up with a mouse click -
        #  but it doesn't hurt either)
        @defer => @focusInput()
      else
        @searchText.set('')

    @listenTo SidebarState, 'change:pinBoardsListSidebar', ->
      @renderSidebarState()
      @updatePinned()
      @updateHeight()
      @ensureUnreadData()

    UserInput.addHandler @, { scope: 'header' }

    @ensureUnreadData()

    @filteredBoardsView = @subview(BoardsSidebarFilteredBoardsView, @model, { @searchText }).render()
    @allBoardsView = @subview(BoardsSidebarAllBoardsView, @model).render()
    @activeBoardsSubview = Hearsay.if @isSearching,
      Hearsay.const(@filteredBoardsView),
      Hearsay.const(@allBoardsView)

    @searchingButtonsView = @subview(BoardsSidebarSearchingButtonsView, @model, { @searchText }).render()
    @boardsButtonsView = @subview(BoardsSidebarBoardsButtonsView, @model).render()
    @activeButtonsSubview = Hearsay.if @isSearching,
      Hearsay.const(@searchingButtonsView),
      Hearsay.const(@boardsButtonsView)

    @subscribe Controller.currentModel.distinct(), ->
      if !SidebarState.getPinSidebar()
        SidebarState.hideSidebar()

    return

  events:
    'keyup .js-search-boards': 'keyEvent'
    'input .js-search-boards': ->
      @searchText.set @$searchInput.val()

    'shortcut': 'shortcut'

  renderOnce: ->
    @$el.html template()

    @renderSidebarState()

    @updatePinned()

    $(window).bind ['resize', @uniqueId()].join('.'), @debounce((=> @updateHeight()), 300)

    @subscribeChanges @activeBoardsSubview,
      out: (oldSubview) ->
        oldSubview.$el.detach()
      in: (newSubview) ->
        @$('.js-board-drawer-boards').append newSubview.el

    @subscribeChanges @activeButtonsSubview,
      out: (oldSubview) ->
        oldSubview.$el.detach()
      in: (newSubview) ->
        @$('.js-board-drawer-buttons').append newSubview.el

    @

  remove: ->
    $(window).unbind ['resize', @uniqueId()].join('.')

    super

  ensureUnreadData: ->
    unreadPollRate = =>
      if Monitor.getStatus() == "active"
        @UNREAD_POLL_RATE_ACTIVE
      else
        @UNREAD_POLL_RATE_IDLE

    if @_lastPoll? && Date.now() - @_lastPoll > unreadPollRate() * 1.5
      @refreshUnreadData()
      @_lastPoll = Date.now()

    if (SidebarState.getShowSidebar() || SidebarState.getPinSidebar())
      if !@_unreadTimeout?
        @_unreadTimeout = @setTimeout =>
          @refreshUnreadData()
          @_unreadTimeout = null
          @_lastPoll = Date.now()
          @ensureUnreadData()
        , unreadPollRate()
    else
      if @_unreadTimeout?
        clearTimeout @_unreadTimeout
        @_unreadTimeout = null

  shortcut: (key) ->
    switch key
      when Keys.B
        if SidebarState.getPinSidebar()
          @focusInput()
        else if SidebarState.getShowSidebar()
          SidebarState.hideSidebar()
        else
          SidebarState.showSidebar()
        true

  clearSearch: ->
    @$searchInput.val("")
    return

  focusInput: ->
    @$searchInput.focus().select()

  refreshUnreadData: ->
    ModelLoader.loadMyBoardsUnreadData().done()
    me = Auth.me()
    for idBoard in SidebarState.getRecentBoards()
      if !me.boardList.get(idBoard) && !me.boardStarList.getBoardStar(idBoard)
        ModelLoader.loadBoardData(idBoard, Payloads.boardUnread).done()
    return

  renderSidebarState: ->
    if SidebarState.getShowSidebar() || SidebarState.getPinSidebar()
      @$el.addClass('is-shown')
      PopOver.hide()
    else
      @$el.removeClass('is-shown')
      @clearSearch()

    @

  updateHeight: ->
    # magic numbers! we want a little extra padding on the top and bottom
    # so the content doesn't bump up again the edge, but there's not really
    # an element to compare against so... magic number. a little less than
    # the window height.
    if SidebarState.getPinSidebar()
      maxHeight = $(window).height() - 50
    else
      maxHeight = $(window).height() - 64

    @$('.board-drawer-content').css
      'max-height': maxHeight

  updatePinned: ->
    @$el.toggleClass('boards-drawer-pinned', SidebarState.getPinSidebar())

    @updateHeight()

  keyEvent: (e) ->
    key = Keyboard.getKey(e)

    if key in [Keys.ArrowUp, Keys.ArrowDown]
      @activeBoardsSubview.get().arrowKeyEvent(e)
      @focusInput()
      return

    if key == Keys.Enter
      @activeBoardsSubview.get().enterKeyEvent(e)
      @focusInput()
      return



// WEBPACK FOOTER //
// ./app/scripts/views/boards-sidebar/boards-sidebar-view.coffee